module.exports = "/_next/static/images/nanny-share-home-186b5c38d423a99c505d5d1ef5f7b1b2.jpg";